import { MetaList } from '@master/model/common/MetaList'
import AccountMeta from './AccountMeta'

export default class AccountMetaList extends MetaList<AccountMeta> {
  constructor (headers: string[], data: (string | number)[][]) {
    super(headers, data, AccountMeta)
  }
}
